module.exports = __webpack_public_path__ + "img/INFJ.a1e5ab8b.png";